import { render, staticRenderFns } from "./AttendanceBtn.vue?vue&type=template&id=1c870d7a&scoped=true&"
import script from "./AttendanceBtn.vue?vue&type=script&lang=js&"
export * from "./AttendanceBtn.vue?vue&type=script&lang=js&"
import style0 from "./AttendanceBtn.vue?vue&type=style&index=0&id=1c870d7a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c870d7a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VItemGroup } from 'vuetify/lib/components/VItemGroup';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VItemGroup,VTooltip})
